const searchStrip = {
  hotels: "โรงแรม", // translated
  city: "เมือง", // translated
  checkIn: "เช็คอิน", // translated
  checkOut: "เช็คเอาท์", // translated
  date: "วันที่", // translated
  persons: "บุคคล", // translated
  adults: "ผู้ใหญ่", // translated
  rooms: "ห้องพัก", // translated
  editSearch: "แก้ไขการค้นหา", // translated
  newSearch: "การค้นหาใหม่", // translated
  listView: "มุมมองรายการ", // translated
  mapView: "มุมมองแผนที่", // translated
};


export default searchStrip;
